import React from "react";
import "./Table.css";

export const Table = ({ children, className = "" }) => {
  return (
    <div className={`table-container ${className}`}>
      <table className="table">{children}</table>
    </div>
  );
};

export const TableHeader = ({ children }) => {
  return (
    <thead className="table__header">
      <tr>{children}</tr>
    </thead>
  );
};

export const TableBody = ({ children }) => {
  return <tbody className="table__body">{children}</tbody>;
};

export const TableRow = ({ children, className = "" }) => {
  return <tr className={`table__row ${className}`}>{children}</tr>;
};

export const TableCell = ({
  children,
  header = false,
  className = "",
  onClick,
  style,
  colSpan
}) => {
  const Component = header ? "th" : "td";
  return (
    <Component colSpan={colSpan} onClick={onClick} className={`table__cell ${className}`} style={style}>
      {children}
    </Component>
  );
};
